import styled from "styled-components";
// import GetHelpIcon from "../../../images/get_help_header.png";

export const TextLink = styled.a`
    text-decoration: none;
    font-family: var(--font-family);
    font-style: normal;
    color:#ffffff;
    &:hover{
        color:#ffffff;
    }
`
export const TextLinkUpdate = styled.a`
    text-decoration: underline;
    font-family: var(--font-family);
    font-style: normal;
    color:Black;
    &:hover{
        color:Black;
    }
`
export const GenericLink = styled(TextLink)`

`

export const ForgotPasswordLink = styled(TextLink)`
     color: #000;
    line-height:1.25;
    font-style: normal;
    font-size: 16px;
    font-family:Lato-Semibold;
    position: relative;
    text-decoration: ${props=>props?.isJPNO == true?"underline":"none"};
    &:hover{
    color: #000;
    }
    @media screen and (min-width: 391px) and (max-width: 749px){
      left: 4%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: portrait){
       
      left:2%;
    }
     @media screen and (min-width: 1200px) and (max-width: 1400px){
      left: 2%;
    }
    @media screen and (min-width: 1400px) and (max-width: 1600px){
      left: 6%;
    }
    @media screen and (min-width: 1600px) {
      left: 8%;
    }

`

export const ReadMoreText = styled.div`
display: flex;
justify-content: flex-end;
margin: 10px 0 10px 0;
color: #FF6B00;
text-decoration: underline;
cursor:pointer;
`

export const GetHelpLink = styled(TextLink)`
    cursor: pointer;
    line-height:1.20;
    font-style: normal;
    // font-weight: 700;
    font-size: 14px;
    // font-family:Lato-Semibold;
    color: #000;
    display:inline-block;
    margin-top: 13px;
    // float: left;
    margin-left: 15px;
    //text-decoration: underline;
    //border-bottom: 1.5px solid black;
    &:hover{
     color: #000;
    }
     
    & img{
        position: relative;
        display: inline-block;
        //content:"";
        //width: 2vh;
        //height: 2vh;
        bottom: 1px;
        // left: -3vh;
        // top: 3px;
        right:8px;
    }
    & span{
         border-bottom: 1.5px solid #000;
    }
    & a{
        color:#000;
        text-decoration: none;
    }
    @media screen and (max-width: 850px){
        //display: block;
        border-bottom: none;
        font-size: 16px;
        font-family:Lato-Semibold;
        border-bottom: 0;
        float: none;
        //margin-left: 0;
        & span{
           /text-decoration: underline;
        }

        // & img{
        //     width: 1.5vh;
        //     height: 1.5vh;
        // }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: portrait){
        margin-top: 13px;
        //float: left;
        margin-left: 15px;
    }
`

export const CookieSettings = styled(GetHelpLink)`
    position:relative;
    text-decoration: underline;
    display:block;
    float:none;
    text-align: left;
    margin-top: 17px;
`
export const OnlineFormText = styled.span`
text-decoration: underline;
cursor: pointer;
`
export const SONumberText = styled.a`
color: black;
text-decoration: underline;
cursor: pointer;
`